module.exports = { "default": require("core-js/library/fn/get-iterator"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** /home/rengasturku/nettivanne/~/babel-runtime/core-js/get-iterator.js
 ** module id = 360
 ** module chunks = 1 2 3 10 11 12 13 14 15 16 17 19 20 21 22 26 33 34
 **/